import React from 'react';
import { Result, Layout } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Content } = Layout;

const EmptyMessage = ({ message, children, ...rest }) => (
  <Content style={{ justifyContent: 'center', alignItems: 'center', marginBottom: '25%' }}>
    <Result
      subTitle={message && <FormattedMessage {...message} values={{ p: chunks => <p>{chunks}</p> }} />}
      {...rest}
    >
      {children}
    </Result>
  </Content>
);

export default EmptyMessage;
